import { render, staticRenderFns } from "./MyTowerCard.vue?vue&type=template&id=7b3a2d31&"
import script from "./MyTowerCard.vue?vue&type=script&lang=js&"
export * from "./MyTowerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports